"use client";
import { useEffect, useContext } from "react";
import { useDataLayerContext } from "./DataLayerContextProvider";
import { BigCommerceStoreContext } from "@/providers/BigCommerceStoreProvider";
import { ProductData } from "@/lib/5874/types";

interface Props {
	products: ProductData[] | undefined;
	scope: string;
}

export default function ViewItemListEvent({ products, scope }: Props) {
	const { viewItemList } = useDataLayerContext();
	const { currencyFormattingRules } = useContext(BigCommerceStoreContext);

	useEffect(() => {
		if (products === undefined) {
			return;
		}
		viewItemList(products, scope, currencyFormattingRules.currency, scope);
	}, [scope]);

	return null;
}
